module.exports = __webpack_public_path__ + "static/media/reserved.b834d33b.svg";